<template>
  <div id="summary-page">
      <v-app>
            <v-content>
                
                <!-- Top charts to display calculations -->
                <v-container class="charts">
                    <DonutChart 
                        id="donut-chart" 
                        :costs="costs"
                        :finalTotal="finalTotal" />
                    <BarChart 
                        id="bar-chart" 
                        v-if="dataReady"
                        :costs="costs" 
                        :average="average"
                        :optimalCosts="optimalCosts"
                        :overSpending="overSpending"  />
                </v-container>

                <v-container class="opportunities">
                    <div class="missed">
                        <h3>Opportunity to Save:</h3>
                        <!-- Replace XXX with totalMissedConditions = costs.forEach(cost => total += (cost - optimal)) -->
                        <h1 v-if="dataReady">${{ totalOS }}</h1>
                    </div>
                    <div class="radials">
                        <RadialChart 
                            label="Prevention" 
                            :num="this.overSpending[0]"
                            :totalOS="this.totalOS"
                            color="#008FFB" />
                        <RadialChart 
                            label="Appraisal" 
                            :num="this.overSpending[1]"
                            :totalOS="this.totalOS"
                            color="#00E396" />
                        <RadialChart 
                            label="Internal Failure" 
                            :num="this.overSpending[2]"
                            :totalOS="this.totalOS"
                            color="#FEB019" />
                        <RadialChart 
                            label="External Failure" 
                            :num="this.overSpending[3]"
                            :totalOS="this.totalOS"
                            color="#FF4560" />
                        <RadialChart 
                            label="Other Types of Waste" 
                            :num="this.overSpending[4]"
                            :totalOS="this.totalOS"
                            color="#775DD0" />
                        <!-- BUG: costs are reset upon click -->
                        <div class="return" @click="$emit('return')">
                            <v-icon x-large color="orange darken-2">fas fa-tachometer-alt</v-icon>
                            <p>Review Costs</p>
                        </div>
                    </div>
                </v-container>
                
                <!-- Contact form to be sent to recruiter -->
                <v-container class="contact-form">

                    <h1>Let Us Help Cut Down Those Costs</h1>
                    <br>
                    <h3>We offer free initial consultations to help assist companies like yours minimize their costs of poor quality</h3>
                    <br>

                    <ContactForm />  

                </v-container>

            </v-content>
        </v-app>
    </div>
</template>

<script>
import BarChart from './Charts/BarChart';
import DonutChart from './Charts/DonutChart';
import RadialChart from './Charts/RadialChart';
import ContactForm from './ContactForm';

export default {
  name: 'summary-page',
    props: ['costs', 'finalTotal', 'companySize', 'average'],
    data: () => ({
        totalOS: null,
        dataReady: false,
        optimalCosts: [],
        overSpending: [],
        nameRules: [
            v => !!v || 'Name is required',
            v => (v && v.length <= 10) || 'Name must be less than 10 characters'
        ],
        emailRules: [
            v => !!v || 'E-mail is required',
            v => /.+@.+/.test(v) || 'E-mail must be valid'
        ]
    }),
    components: {
        BarChart,
        DonutChart,
        RadialChart,
        ContactForm
    },
    methods: {
    },
    created: function() {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;

        for (let key in this.costs) {
            this.optimalCosts.push(this.costs[key] * 0.85);
            this.overSpending.push((this.costs[key] * 0.15))
        };

        this.totalOS = this.overSpending.reduce((a,b) => a + b).toFixed(0);
        this.dataReady = true;
    }
}
</script>
<style scoped>
.cell {
    padding: 0.5rem;
}
.contact-form {
    background-color: white;
    margin-bottom: 2rem;
    border-radius: 25px;
    box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);
}
.charts {
    display: flex;
    justify-content: flex-start;
}
#donut-chart {
    background: white;
    border-radius: 25px;
    padding: 1rem;
    margin: 1rem;
    box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);
}
#bar-chart {
    background: white;
    flex-grow: 1;
    border-radius: 25px;
    padding: 1rem;
    margin: 1rem;
    box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);
}

.opportunities {
    display: flex;
    margin-top: -3rem;
}

.radials {
    display:flex;
    flex-wrap: wrap;
    flex: 1
}

.missed {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: 1rem;
    padding: 1rem;
    flex: 1;
    background: white;
    border-radius: 25px;
    box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);
}

.return {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin:1rem;
    padding-left: 2.5rem;
    padding-right: 2.5rem;
    background: white;
    border-radius: 15px;
    cursor: pointer;
    box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);
}

.missed > h1 {
    color: green;
}

@media screen and (min-width: 320px) and (max-width: 800px){
  .charts {
    flex-direction: column;
  }
  .opportunities {
      flex-direction: column;
  }
  .radials {
      justify-content: center;
  }
}
</style>